import { removeItem } from "./index.js";

// add clicked test to selectedTestIdList
// selectProp: String(ex: isSelect, isSelectForShortcut)
export function addSelectedTest(testId, selectProp, supportObj) {
  let { testNodeList, selectedTestIdList } = supportObj;
  if (selectedTestIdList.includes(testId)) {
    return;
  }
  let currentNode = getTestNode(testNodeList, testId === 151 ? 60 : testId === 594 ? 586 : testId);
  if (!currentNode) {
    return;
  }
  // if its parent node is selected, return
  if (currentNode.parent && currentNode.parent.value[selectProp])
    return;
  // if duplicate test (string id), and other duplicate one is already selected
  // i.e. select "371_24" when "371_26" is already selected
  if (typeof testId === "string") {
    // find all duplicate tests
    let duplicateId = Number(testId.split("_")[0]);
    let duplicateNodes = testNodeList.filter(node => node.value.originalId === duplicateId);
    // check whether any duplicate test(except currentNode itself) is selected, if any, return
    let isAnySelected = duplicateNodes.some(node => node.id !== testId && node.value[selectProp]);
    if (isAnySelected) {
      currentNode.value[selectProp] = true;
      return;
    }
  }
  // select test and its content
  handleTestSelection(currentNode, selectProp, true);
  // dispatch("handleTestSelection", { testId: test.id, isSelectTest: true });
  // add to selected test list
  // special case: if wheat zoomer complete(151/594) is selected, add wheat zoomer(60/586) instead
  selectedTestIdList.push(currentNode.id === 151 ? 60 : currentNode.id === 594 ? 586 : currentNode.id);
  // remove all children of the currentNode from selectedTestIdList
  let descendantList = [];
  getAllDescendants(currentNode, descendantList);
  descendantList.forEach(node => {
    removeItem(node.id, selectedTestIdList);
  });
}

export function removeSelectedTest(testId, selectProp, supportObj) {
  let { 
    testNodeList, 
    selectedTestIdList, 
    bundleList,
    selectedDiscountPanelIdList, 
    selectedXChooseYPanelIdList, 
    selectedCustomPanelIdList, 
    selectedSeasonalPromoList, 
    shortcutList, 
    selectedShortcutIdList 
  } = supportObj;
  // get current selected node
  let currentNode = getTestNode(testNodeList, testId);
  if (!currentNode) {
    return;
  }
  // special case: if test is wheat zoomer complete(id: 151), change to its' parent wheat zoomer(id: 60)
  // if test is wheat DBS(id: 586), change to its' parent food zoomer if exists and parent's select prop is true
  // note that food zoomer may not exist as it currently only in new menu
  if ([151, 594].includes(currentNode.id)) {
    currentNode = currentNode.parent || currentNode;
  } else if (currentNode.id === 586) {
    // wheat DBS: only replace with parent if parent's select prop is true
    if (currentNode.parent && currentNode.parent.value[selectProp]) {
      currentNode = currentNode.parent;
    }
  }
  // get a path from currentNode's first selected ancestor to itself.
  // if the path only includes currentNode, the node is selected by itself
  // otherwise it is included in other group test
  let path = getSelectedNodePath(currentNode, selectProp);
  // if currentNode is duplicate (string id),
  // check whether there are any other duplicate tests are selected solely
  // if so, randomly pick one add to selected list
  if (typeof testId === "string") {
    // find all duplicate tests except current removed one
    let duplicateId = Number(testId.split("_")[0]);
    let duplicateNodes = testNodeList.filter(node => node.id !== testId && node.value.originalId === duplicateId);
    duplicateNodes.forEach(node => {
      removeItem(node.id, selectedTestIdList);
      if (node.parent && !node.parent.value[selectProp]) {
        node.value[selectProp] = false;
      }
    });
  }
  // if currentNode is selected or the group including currentNode is selected
  if (selectedTestIdList.includes(path[0].id)) {
    // remove path[0]'s id
    removeItem(path[0].id, selectedTestIdList);
  }

  // check whether current selected test belongs to any selected discount panel
  let selectedDiscountPanelList = bundleList
    .filter(b => selectedDiscountPanelIdList.includes(b.bundleId));
  selectedDiscountPanelList.forEach(panel => {
    removeTestInDiscountPanel(path[0].id, panel, selectProp, panel.bundleId, selectedDiscountPanelIdList, supportObj);
  });

  // check whether belong to any xChooseY panel
  let selectedXChooseYPanelList = bundleList
    .filter(b => selectedXChooseYPanelIdList.includes(b.bundleId));
  selectedXChooseYPanelList.forEach(panel => {
    removeTestInXChooseYPanel(path[0].id, panel, selectProp, panel.bundleId, selectedXChooseYPanelIdList, supportObj);
  });

  // check whether belong to any selected custom panel
  let selectedCustomPanelList = bundleList
    .filter(b => selectedCustomPanelIdList.includes(b.bundleId));
  selectedCustomPanelList.forEach(customPanel => {
    removeTestInCustomPanel(path[0].id, customPanel, selectProp, customPanel.bundleId, selectedCustomPanelIdList, supportObj);
  });

  // check whether belong to any seasonal promo
  selectedSeasonalPromoList.forEach(promo => {
    removeTestInSeasonalPromo(path[0].id, promo, selectProp, promo, selectedSeasonalPromoList, supportObj);
  });

  // check whether belong to any shortcuts
  let selectedShortcutList = shortcutList
    .filter(shortcut => selectedShortcutIdList.includes(shortcut.id));
  selectedShortcutList.forEach(shortcut => {
    removeTestInShortcut(path[0].id, shortcut, selectProp, shortcut.id, selectedShortcutIdList, supportObj);
  })  

  // de-select all subtree nodes rooted at currentNode
  handleTestSelection(currentNode, selectProp, false);
  // de-select all the test on the path
  path.forEach(node => node.value[selectProp] = false);
  // for each node in path, add descendants (exclude the one in path) 
  // to selectedTestList
  for (let i = 0; i < path.length-1; i++) {
    path[i].descendants.forEach(node => {
      if (node.id !== path[i+1].id) {
        addSelectedTest(node.id, selectProp, supportObj);
      }
    });
  }

  // remove currentNode or the group including currentNode in edit order item list if any
  // note: only call when remove from order test menu on the page, not from the one in shortcut 
  if (selectProp === "isSelect") {
    removeSelectedTestInEditOrder(path[0].id, supportObj);
  }
}

// recursively select/de-select all the nodes' selectProp in the sub tree according to isSelectTest
export function handleTestSelection(root, selectProp, isSelectTest) {
  if (!root) {
    return;
  }
  // select/de-select current test according to isSelectTest value
  root.value[selectProp] = isSelectTest;
  // loop for descendants
  root.descendants.forEach(node => {
    handleTestSelection(node, selectProp, isSelectTest);
  });
}

export function getAllDescendants(root, descendantList) {
  if(!root) {
    return;
  }
  root.descendants.forEach(node => {
    descendantList.push(node);
    getAllDescendants(node, descendantList);
  });
}

export function getTestNode(testNodeList, id) {
  let node = testNodeList.find(node => node.id === id);
  if (!node) {
    // given id may be the original id for duplicate tests, ex: id 371
    node = testNodeList.find(node => node.value.originalId === id);
  }
  return node;
}

function getSelectedNodePath(node, selectProp) {
  let path = [];
  path.push(node);
  let currentNode = node.parent;
  while (currentNode !== null && currentNode.value[selectProp]) {
    path.unshift(currentNode);
    currentNode = currentNode.parent;
  }
  return path;
}

function removeSelectedTestInEditOrder(testId, supportObj) {
  let { editOrderItemList, bundleList, seasonalPromotionList, shortcutList } = supportObj;
  // remove test in edit order list
  let test = editOrderItemList
    .find(item => item.item_id === testId && ["va", "vw"].includes(item.category));
  removeItem(test, editOrderItemList);

  // remove discount panel if the test is included in discount panel
  editOrderItemList.filter(item => item.category === "discountPanel").forEach(panel => {
    let panelOnMenu = bundleList.find(item => item.bundleId === panel.item_id);
    removeTestInDiscountPanel(testId, panelOnMenu, "isSelect", panel, editOrderItemList, supportObj);
  });

  // remove xChooseY panel if test belongs to x choose y 
  editOrderItemList.filter(item => item.category === "xChooseY").forEach(panel => {
    let panelOnMenu = bundleList.find(item => item.bundleId === panel.item_id);
    removeTestInXChooseYPanel(testId, panelOnMenu, "isSelect", panel, editOrderItemList, supportObj);
  });
  
  // remove custom panel if the test is included in custom panel
  editOrderItemList.filter(item => item.category === "customPanel").forEach(panel => {
    let panelOnMenu = bundleList.find(item => item.bundleId === panel.item_id);
    removeTestInCustomPanel(testId, panelOnMenu, "isSelect", panel, editOrderItemList, supportObj);
  });

  // remove seasonal promo if the test is included in seasonal promo
  editOrderItemList.filter(item => item.category === "seasonalPromo").forEach(promo => {
    let promoOnMenu = seasonalPromotionList.find(p => p.id == promo.item_id);
    removeTestInSeasonalPromo(testId, promoOnMenu, "isSelect", promo, editOrderItemList, supportObj);
  });

  // remove shortcut if the test is included in shortcut
  editOrderItemList.filter(item => item.category === "shortcut").forEach(shortcut => {
    let shortcutOnMenu = shortcutList.find(s => s.id === shortcut.item_id);
    removeTestInShortcut(testId, shortcutOnMenu, "isSelect", shortcut, editOrderItemList, supportObj);
  })
}

function removeTestInDiscountPanel(testId, discountPanel, selectProp, removedDiscountPanel, removeFromList, supportObj) {
  if (!discountPanel) {
    return;
  }
  let { testNodeList } = supportObj;
  let idList = [...discountPanel.testIdsInPanel];
  let index = idList.indexOf(testId);
  if (index > -1) { // current test belong to current panel
    // remove current selected panel itself
    removeItem(removedDiscountPanel, removeFromList);
    // de-select panel
    discountPanel[selectProp] = false;
    // add remaining tests to selectedTestList
    idList.splice(index, 1);
    idList.forEach(testId => {
      let node = getTestNode(testNodeList, testId);
      addSelectedTest(node.id, selectProp, supportObj);
    });
  }
}

function removeTestInXChooseYPanel(testId, xChooseYPanel, selectProp, removedXChooseY, removeFromList, supporObj) {
  let { selectedTestIdList } = supporObj;
  // get tests in current panel
  if (!xChooseYPanel || !xChooseYPanel.selectedZoomerIdList) {
    return;
  }
  let testIdList = xChooseYPanel.selectedZoomerIdList.concat(xChooseYPanel.selectedSupplementIdList);
  let index = testIdList.indexOf(testId);
  // if included in current panel
  if (index > -1) {
    // de-select xChooseY panel
    xChooseYPanel[selectProp] = false;
    // remove current xChooseY panel from selected list
    removeItem(removedXChooseY, removeFromList);
    // add remaining tests to selectedTestList
    testIdList.splice(index, 1);
    testIdList.forEach(testId => {
      selectedTestIdList.push(testId);
    });
  }
}

function removeTestInCustomPanel(testId, customPanel, selectProp, removedCustomPanel, removeFromList, supportObj) {
  if (!customPanel) {
    return;
  }
  let { bundleList, selectedTestIdList, selectedDiscountPanelIdList, selectedXChooseYPanelIdList  } = supportObj;
  // get all tests that belongs to current custom panel
  let testIdList = customPanel.bundleItemList
    .filter(item => item.itemType !== "official bundle")
    .map(item => item.itemId);
  // get discount and xChooseY panels
  let panelIdList = customPanel.bundleItemList
    .filter(item => item.itemType === "official bundle")
    .map(item => item.itemId);
  let discountPanelList = [];
  let xChooseYPanelList = [];
  panelIdList.forEach(id => {
    let bundle = bundleList.find(panel => panel.bundleId === id);
    if (bundle) {
      bundle.category === "discountPanel"
        ? discountPanelList.push(bundle)
        : xChooseYPanelList.push(bundle);
    }
  })
  // if test belong to current customPanel
  let index = testIdList.indexOf(testId);
  if (index > -1) {
    // de-select current customPanel
    customPanel[selectProp] = false;
    // remove current customPanel
    removeItem(removedCustomPanel, removeFromList);
    // add remaining tests to selectedTestList
    testIdList.splice(index, 1);
    testIdList.forEach(testId => {
      selectedTestIdList.push(testId)
    });
    // add current customPanel's discount panel
    discountPanelList.forEach(panel => {
      selectedDiscountPanelIdList.push(panel.bundleId);
    });
    // add current customPanel's xChooseY panel
    xChooseYPanelList.forEach(panel => {
      selectedXChooseYPanelIdList.push(panel.bundleId);
    });
  }
  else {
    // check whether it belongs to any custom bundle's discount panels
    let remainingDiscountPanelIdList = [];
    discountPanelList.forEach(discountPanel => {
      let idList = discountPanel.bundleContent.packageList.map(p => p.packageId)
        .concat(discountPanel.bundleContent.testList.map(t => t.testId));
      let index = idList.indexOf(testId);
      // if test belong to current discount panel
      if (index > -1) {
        // de-select current discount panel
        discountPanel[selectProp] = false;
        // add remaing tests to selectedTestList
        idList.splice(index, 1);
        idList.forEach(testId => {
          selectedTestIdList.push(testId);
        });
      }
      else {
        // if not, store it to remainingDiscountPanelIdList 
        remainingDiscountPanelIdList.push(discountPanel.bundleId);
      }
    });
    // if test belongs to any discount panels
    if (remainingDiscountPanelIdList.length < discountPanelList.length) {
      // de-select current customPanel
      customPanel[selectProp] = false;
      // remove custom panel
      removeItem(removedCustomPanel, removeFromList);
      // add remaining discount panels to selectedDiscountPanelList
      remainingDiscountPanelIdList.forEach(panelId => {
        selectedDiscountPanelIdList.push(panelId);
      });
      // add current customPanel's tests to selectedTestList
      testIdList.forEach(testId => {
        selectedTestIdList.push(testId);
      });
      // add current customPanel's xChooseY panel to selectedXChooseY panel list
      xChooseYPanelList.forEach(panel => {
        selectedXChooseYPanelIdList.push(panel.bundleId)
      });
    }
    else {
      // check whether it belong to any custom bundle's xChooseY panel
      let remainingXChooseYPanelList = []
      xChooseYPanelList.forEach(panel => {
        let idList = (panel.selectedZoomerIdList ? panel.selectedZoomerIdList : [])
          .concat(panel.selectedSupplementIdList ? panel.selectedSupplementIdList : []);
        // if test belongs to current xChooseY panel
        let index = idList.indexOf(testId);
        if (index > -1) {
          // de-select current xChooseY panel
          panel[selectProp] = false;
          // add remaing tests to selectedTestList
          idList.splice(index, 1);
          idList.forEach(testId => {
            selectedTestIdList.push(testId);
          });
        }
        else {
          remainingXChooseYPanelList.push(panel);
        }
      })
      // if there exists xChooseY panels including the test
      if (remainingXChooseYPanelList.length < xChooseYPanelList.length) {
        // de-sure current customPanel
        customPanel[selectProp] = false;
        // remove current customPanel
        removeItem(removedCustomPanel, removeFromList);
        // add discount panels
        discountPanelList.forEach(panel => {
          selectedDiscountPanelIdList.push(panel.bundleId);
        });
        // add current customPanel's tests
        testIdList.forEach(testId => {
          selectedTestIdList.push(testId);
        });
        // add remaining xChooseY panels
        remainingXChooseYPanelList.forEach(panel => {
          selectedXChooseYPanelIdList.push(panel.bundleId);
        });
      }
    }
  }
}

function removeTestInSeasonalPromo(testId, promo, selectProp, removedPromo, removeFromList, supportObj) {
  let { bundleList, selectedTestIdList, selectedDiscountPanelIdList } = supportObj;
  let idSet = new Set(promo.appliedTests);
  // get test ids from promo's bundle if any
  promo.appliedBundles.forEach(bundleId => {
    // get package and test id list
    let discountPanel = bundleList.find(t => t.bundleId === bundleId);
    if (discountPanel) {
      idSet = new Set([...idSet, ...discountPanel.testIdsInPanel]);
    }
  });
  if (idSet.has(testId)) { // belong to current promo
    // de-select current promo
    promo[selectProp] = false;
    // remove current promo
    removeItem(removedPromo, removeFromList);
    // add remaining tests and bundles
    idSet.delete(testId);
    idSet.forEach(testId => {
      selectedTestIdList.push(testId);
    });
    promo.appliedBundles.forEach(bundleId => {
      selectedDiscountPanelIdList.push(bundleId);
    });
  }
}

function removeTestInShortcut(testId, shortcut, selectProp, removedShortcut, removeFromList, supportObj) {
  if (!shortcut) {
    return;
  }
  let { testIdList, discountPanelIdList, customPanelIdList, selectedXChooseYPanelList } = shortcut;
  let { selectedTestIdList, selectedDiscountPanelIdList, selectedCustomPanelIdList, selectedXChooseYPanelIdList, bundleList } = supportObj;
  let index = testIdList.indexOf(testId);
  // if belong to current shortcut
  if (index > -1) {
    // de-select & remove current shortcut
    shortcut[selectProp] = false;
    removeItem(removedShortcut, removeFromList);
    // add remaining test
    let remainingTestIdList = [...testIdList];
    remainingTestIdList.splice(index, 1);
    remainingTestIdList.forEach(id => {
      selectedTestIdList.push(id);
    });
    // add discount panels
    discountPanelIdList.forEach(id => {
      selectedDiscountPanelIdList.push(id);
    });
    // add custom panels
    customPanelIdList.forEach(id => {
      selectedCustomPanelIdList.push(id);
    });
    // add x choose y panels
    if (selectedXChooseYPanelList) {
      selectedXChooseYPanelList.filter(xChooseY => !xChooseY.customPanelId)
        .filter(xChooseY => {
          selectedXChooseYPanelIdList.push(xChooseY.bundleId);
        });
    }
  }
  else {
    // check whether belong to any of current shortcut's discount panel
    let discountPanelList = bundleList
      .filter(bundle => discountPanelIdList.includes(bundle.bundleId));
    let remainingDiscountPanelIdList = [];
    discountPanelList.forEach(discountPanel => {
      // get package and test id list
      let idList = discountPanel.bundleContent.packageList.map(p => p.packageId)
        .concat(discountPanel.bundleContent.testList.map(t => t.testId));
      let index = idList.indexOf(testId);
      if (index > -1) { // current test belong to current panel
        // de-select & remove current shortcut
        shortcut[selectProp] = false;
        removeItem(removedShortcut, removeFromList);
        // add remaining tests to selectedTestList
        idList.splice(index, 1);
        idList.forEach(testId => {
          selectedTestIdList.push(testId);
        });
      }
      else {
        remainingDiscountPanelIdList.push(discountPanel.bundleId);
      }
    });
    // if current test belong to any discount panel
    if (remainingDiscountPanelIdList.length < discountPanelIdList.length) {
      // add test
      testIdList.forEach(id => {
        selectedTestIdList.push(id);
      });
      // add remaining discount panel
      remainingDiscountPanelIdList.forEach(id => {
        selectedDiscountPanelIdList.push(id);
      });
      // add custom panel
      customPanelIdList.forEach(id => {
        selectedCustomPanelIdList.push(id);
      });
      // add xChooseY panel
      if (selectedXChooseYPanelList) {
        selectedXChooseYPanelList.filter(xChooseY => !xChooseY.customPanelId)
          .forEach(xChooseY => {
            selectedXChooseYPanelIdList.push(xChooseY.bundleId);
          });
      }
    }
    else {
      // check whether belong to any of current shortcut's xChooseY panel
      let remainingXChooseYPanelList = [];
      if (selectedXChooseYPanelList) {
        selectedXChooseYPanelList.forEach(xChooseY => {
          let idList = xChooseY.selectedZoomerIdList.concat(xChooseY.selectedSupplementIdList);
          let index = idList.indexOf(testId);
          // if belong to xChooseY
          if (index > -1) {
            // de-select & remove shortcut
            shortcut[selectProp] = false;
            removeItem(removedShortcut, removeFromList);
            // add remaining tests in this xChooseY panel
            idList.splice(index, 1);
            idList.forEach(id => {
              selectedTestIdList.push(id);
            });
          }
          else {
            remainingXChooseYPanelList.push(xChooseY);
          }
        });
      }
      // if belong to any of current shortcut's xChooseY panel
      if (selectedXChooseYPanelList && remainingXChooseYPanelList.length < selectedXChooseYPanelList.length) {
        // add tests
        testIdList.forEach(id => {
          selectedTestIdList.push(id);
        });
        // add discount panels
        discountPanelIdList.forEach(id => {
          selectedDiscountPanelIdList.push(id);
        });
        // add custom panels
        customPanelIdList.forEach(id => {
          selectedCustomPanelIdList.push(id);
        });
        // add remaining xChooseY
        remainingXChooseYPanelList.filter(xChooseY => !xChooseY.customPanelId)
          .forEach(xChooseY => {
            selectedXChooseYPanelIdList.push(xChooseY.bundleId);
          });
      }
      else {
        // check whether belong to any of shortcut's custom panel
        let customPanelList = bundleList
          .filter(bundle => customPanelIdList.includes(bundle.bundleId));
        let remainingCustomPanelIdList = [];
        customPanelList.forEach(customPanel => {
          // get all tests that belongs to current custom panel
          let testIdList = customPanel.bundleItemList
            .filter(item => item.itemType !== "official bundle")
            .map(item => item.itemId);
          // get discount and xChooseY panels
          let panelIdList = customPanel.bundleItemList
            .filter(item => item.itemType === "official bundle")
            .map(item => item.itemId);
          let discountPanelList = [];
          let xChooseYPanelList = [];
          panelIdList.forEach(id => {
            let bundle = bundleList.find(panel => panel.bundleId === id);
            if (bundle) {
              bundle.category === "discountPanel"
                ? discountPanelList.push(bundle)
                : xChooseYPanelList.push(bundle);
            }
          });
          // if test belong to current customPanel
          let index = testIdList.indexOf(testId);
          if (index > -1) {
            // de-select & remove current shortcut
            shortcut[selectProp] = false;
            removeItem(removedShortcut, removeFromList);
            // add remaining tests to selectedTestList
            testIdList.splice(index, 1);
            testIdList.forEach(testId => {
              selectedTestIdList.push(testId);
            });
            // add current customPanel's discount panel
            discountPanelList.forEach(panel => {
              selectedDiscountPanelIdList.push(panel.bundleId);
            });
            // add current customPanel's xChooseY panel
            xChooseYPanelList.forEach(panel => {
              selectedXChooseYPanelIdList.push(panel.bundleId);
            });
          }
          else {
            // check whether it belongs to any custom bundle's discount panels
            let remainingDiscountPanelIdList = [];
            discountPanelList.forEach(discountPanel => {
              let idList = discountPanel.bundleContent.packageList.map(p => p.packageId)
                .concat(discountPanel.bundleContent.testList.map(t => t.testId));
              let index = idList.indexOf(testId);
              // if test belong to current discount panel
              if (index > -1) {
                // de-select & remove current shortcut
                shortcut[selectProp] = false;
                removeItem(removedShortcut, removeFromList);
                // add remaing tests to selectedTestList
                idList.splice(index, 1);
                idList.forEach(testId => {
                  selectedTestIdList.push(testId);
                });
              }
              else {
                // if not, store it to remainingDiscountPanelIdList 
                remainingDiscountPanelIdList.push(discountPanel.bundleId);
              }
            });
            // if test belongs to any discount panels
            if (remainingDiscountPanelIdList.length < discountPanelList.length) {
              // add remaining discount panels to selectedDiscountPanelList
              remainingDiscountPanelIdList.forEach(panelId => {
                selectedDiscountPanelIdList.push(panelId);
              });
              // add current customPanel's tests to selectedTestList
              testIdList.forEach(testId => {
                selectedTestIdList.push(testId);
              });
              // add current customPanel's xChooseY panel to selectedXChooseY panel list
              xChooseYPanelList.forEach(panel => {
                selectedXChooseYPanelIdList.push(panel.bundleId)
              });
            }
            else {
              // check whether it belong to any custom bundle's xChooseY panel
              let remainingXChooseYPanelList = [];
              xChooseYPanelList.forEach(panel => {
                let idList = (panel.selectedZoomerIdList ? panel.selectedZoomerIdList : [])
                  .concat(panel.selectedSupplementIdList ? panel.selectedSupplementIdList : []);
                // if test belongs to current xChooseY panel
                let index = idList.indexOf(testId);
                if (index > -1) {
                  // de-select & remove current shortcut
                  shortcut[selectProp] = false;
                  removeItem(removedShortcut, removeFromList);
                  // add remaing tests to selectedTestList
                  idList.splice(index, 1);
                  idList.forEach(testId => {
                    selectedTestIdList.push(testId);
                  });
                }
                else {
                  remainingXChooseYPanelList.push(panel);
                }
              });
              // if there exists xChooseY panels including the test
              if (remainingXChooseYPanelList.length < xChooseYPanelList.length) {
                // add discount panels
                discountPanelList.forEach(panel => {
                  selectedDiscountPanelIdList.push(panel.bundleId);
                });
                // add current customPanel's tests
                testIdList.forEach(testId => {
                  selectedTestIdList.push(testId);
                });
                // add remaining xChooseY panels
                remainingXChooseYPanelList.forEach(panel => {
                  selectedXChooseYPanelIdList.push(panel.bundleId);
                });
              }
              else {
                remainingCustomPanelIdList.push(customPanelIdList);
              }
            }
          }
        });
        if (remainingCustomPanelIdList.length < customPanelIdList.length) {
          // add tests
          testIdList.forEach(id => {
            selectedTestIdList.push(id);
          });
          // add discount panels
          discountPanelIdList.forEach(id => {
            selectedDiscountPanelIdList.push(id);
          });
          // add custom panels
          customPanelIdList.forEach(id => {
            selectedCustomPanelIdList.push(id);
          });
          // add xChooseY panels
          if (selectedXChooseYPanelList) {
            selectedXChooseYPanelList.filter(xChooseY => !xChooseY.customPanelId)
              .forEach(xChooseY => {
                selectedXChooseYPanelIdList.push(xChooseY.bundleId);
              });
          }
        }
      }
    }

  }
}